import styled from 'styled-components';
import { rem } from 'polished';

const ColorVariantContainer = styled.div`
    margin: ${rem(8)} 0 ${rem(16)};
`;

export default ColorVariantContainer;
